__turbopack_context__.v({
  "button-container": "LoginForm-module__upvV6W__button-container",
  "error": "LoginForm-module__upvV6W__error",
  "login-button-container": "LoginForm-module__upvV6W__login-button-container",
  "login-form": "LoginForm-module__upvV6W__login-form",
  "login-inputs": "LoginForm-module__upvV6W__login-inputs",
});
